<template>
  <div v-if="podcast" class="home-podcast-slide py-4 py-md-0">
    <router-link
      :to="{
        name: 'podcast-episodes',
        params: { ...podcast }
      }"
    >
      <img :src="podcast.photo" class="img-fluid" />
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    podcast: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>

<style lang="scss" scoped>
.home-podcast-slide {
  img {
    width: 100%;
    border-radius: 3px;
  }

  a {
    font-size: 14px;
  }
}
</style>
